import { useAuth } from '@/contexts/AuthContext';
import { useCampaignStore } from '@/stores';

/**
 * Whether the user may create, edit, reschedule, assign and delete the selected campaign's
 * tasks and shifts. The client side of the API's `[RequireCapability(FieldOps, Manage)]`,
 * which admits a platform admin before it reads capabilities; the store's `canManage` has no
 * platform-admin bypass, so it can't stand alone. Claiming, accepting and completing a task
 * are per-record and stay open to every member.
 */
export function useMayManageTasks(): boolean {
  const { user } = useAuth();
  const canManageFieldOps = useCampaignStore((s) => s.canManage('FieldOps'));
  return (user?.isPlatformAdmin ?? false) || canManageFieldOps;
}
